/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Modal, ModalBody, ModalHeader, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountLoyaltyViewProps } from './account-loyalty';

const AccountLoyaltyView: React.FC<IAccountLoyaltyViewProps> = props => {

    const { AccountLoyalty, Info, Points, Breakdown, RewardPoints, PointsBreakdown, Button, heading, infoLabel, cardNumber, joinDate, pointsLabel, points, rewardPoints, homeButton, pointsModal } = props;
    const { ModalBodyTop, ModalBodyHeaders } = pointsModal;
    return (
        <Module {...AccountLoyalty}>
            {heading}
            <Node {...Info}>
                {infoLabel}
                {cardNumber}
                {joinDate}
            </Node>
            <Node {...Points}>
                {pointsLabel}
                {points}

                <Node {...Breakdown}>
                    {rewardPoints && rewardPoints.map((activity, index) => {
                        return (

                            <Node key={index} {...RewardPoints}>
                                {activity.label}
                                <Node {...PointsBreakdown}>
                                    {activity.availableModalLabel}
                                    {activity.availableModalTrigger}
                                </Node>

                                <Node {...PointsBreakdown}>
                                    {activity.expiringModalLabel}
                                    {activity.expiringModalTrigger}
                                </Node>
                            </Node>
                        );
                    })}
                </Node>
            </Node>

            <Node {...Button}>
                {homeButton}
            </Node>

            {!pointsModal.isOpen &&
                <Modal
                    returnFocusRef={pointsModal.returnFocusRef}
                /> ||
                <Module
                    tag={Modal}
                    {...AccountLoyalty}
                    // eslint-disable-next-line jsx-a11y/no-autofocus -- Needed autofocus in modal.
                    autoFocus
                    fade
                    returnFocusRef={pointsModal.returnFocusRef}
                    isOpen={pointsModal.isOpen}
                    horizontalPosition={pointsModal.horizontalPosition}
                    verticalPosition={pointsModal.verticalPosition}
                    className={pointsModal.modalClassName!}
                    zIndex={1050}
                    onClosed={pointsModal.onClose}
                    onOpened={pointsModal.onOpened}
                    toggle={pointsModal.onClose}
                >

                    <ModalHeader toggle={pointsModal.onClose} className={pointsModal.modalHeaderClassName}>
                        {pointsModal.modalHeader}
                    </ModalHeader>
                    <ModalBody className={pointsModal.modalBodyClassName}>
                        <Node {...ModalBodyTop}>
                            {pointsModal.pointsDescription}
                            {pointsModal.totalPoints}
                        </Node>
                        <Node {...ModalBodyHeaders}>
                            {pointsModal.date}
                            {pointsModal.balanceLabel}
                        </Node>
                        {pointsModal.rewardPointsActivity && pointsModal.rewardPointsActivity.map((activity, index) => {
                            const { Activity, activityType, activityDate, activityPoints } = activity;
                            return (
                                <Node {...Activity} key={index}>
                                    {activityType}
                                    {activityDate}
                                    {activityPoints}
                                </Node>
                            );
                        })}
                    </ModalBody>
                </Module>}
        </Module>
    );
};

export default AccountLoyaltyView;
